<!-- SPDX-License-Identifier: LicenseRef-MMS-WIRE -->
<!-- Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd -->

<div class="timezone-selector-trigger" xmlns="http://www.w3.org/1999/html">
  <img src='/static/icons/date-period_1.png'
    class="date-period-icon"
    [matTooltip]="active_timezone"
    [matMenuTriggerFor]="timezoneSelectorMenu" alt=""/>
</div>


<mat-menu #timezoneSelectorMenu="matMenu" class="timezone-selector" [ngClass]="'timezone-selector'">
  @for (option of timezone_options; track option) {
    <button (click)="changeTimezone(option.value)"
      [ngClass]="{'active-timezone': option.value === active_timezone}">
      <div>{{option.alias ? option.alias : option.name}} <small>({{option.offset}})</small></div>
    </button>
  }
</mat-menu>


@if (show_clock) {
  <div class="timezone-clock" [ngClass]="{'clock-min' : clock_min }"
    [matTooltip]="clock_min ? 'Show time in selected timezone of ' + active_timezone : 'Time in selected timezone: ' + active_timezone">
    @if (!clock_min) {
      <div>{{clock | date: 'd MMM HH:mm (z)' : active_timezone_offset_string}}</div>
    }
    <div>
      @if (!clock_min) {
        <i (click)="toggleTimezoneClock(true)" class="fa fa-caret-up"></i>
      }
      <i (click)="toggleTimezoneClock(!clock_min)" class="fa fa-clock"></i>
    </div>
  </div>
}
